import React, { useEffect, useState } from 'react';
import './my-gpts.css';
import CloseIcon from '../images/close.png';
import { getData } from '../utils/apis/api';
import AdminSettings from './admin-settings';
import Loader from '../components/loader';
import CustomToaster from '../components/custom-toaster';

const MyGptsPopup = ({ onClose }) => {
  const [gptData, setGptData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');

  // Fetch GPT data
  const fetchGptData = async () => {
    setIsLoading(true);
    setShowToast(false);
    try {
      const data = await getData(
        `/my_gpts?user_id=${sessionStorage.getItem('user_id')}`
      );
      setGptData(data);
    } catch (error) {
      setToastMessage('Failed to load GPT data.');
      setToastVariant('error');
    } finally {
      setShowToast(true);
      setIsLoading(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setToastMessage('Link copied to clipboard!');
    setToastVariant('success');
    setShowToast(true);
  };

  const handleEditClick = (gpt) => {
    setSelectedAgent(gpt);
    setIsEditing(true);
  };

  useEffect(() => {
    fetchGptData();
  }, []);

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="popup-header d-flex justify-content-between">
          <h2>My GPTs</h2>
          <button className="modal-close" onClick={onClose}>
            <img src={CloseIcon} alt="close" width="10" />
          </button>
        </div>

        {isLoading ? (
          <Loader />
        ) : (
          <table className="gpt-table">
            <thead>
              <tr>
                <th>GPT Name</th>
                <th>Link</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {gptData.map((gpt, index) => (
                <tr key={index}>
                  {/* GPT Name with Tooltip */}
                  <td className="tooltip-container">
                    <span className="text-truncate" title={gpt.gptName}>{gpt.gptName}</span>
                    <div className="tooltip-content">{gpt.gptName}</div>
                  </td>

                  {/* Link with Tooltip */}
                  <td className="tooltip-container">
                    <span className="text-truncate" title={gpt.link}>{gpt.link}</span>
                    <div className="tooltip-content">{gpt.link}</div>
                  </td>

                  <td>
                    <div className="actions">
                      <button
                        className="TransButton"
                        onClick={() => copyToClipboard(gpt.link)}
                        title="Copy Link"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-copy"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                          />
                        </svg>
                      </button>
                      <button
                        className="TransButton"
                        onClick={() => handleEditClick(gpt)}
                        title="Edit GPT"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-pencil-square"
                          viewBox="0 0 16 16"
                        >
                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                          <path
                            fillRule="evenodd"
                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                          />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {isEditing && (
          <AdminSettings
            onClose={() => setIsEditing(false)}
            onSave={() => {
              fetchGptData();
              setIsEditing(false);
            }}
            agentName={selectedAgent.gptName}
            isEdit={true}
          />
        )}

        {toastMessage && (
          <CustomToaster
            show={showToast}
            onClose={() => setShowToast(false)}
            message={toastMessage}
            type={toastVariant}
          />
        )}
      </div>
    </div>
  );
};

export default MyGptsPopup;
